import { render } from './render';
import { setStyles } from './set-styles';
export var createNode = function (children, attrs, styles) {
    if (attrs === void 0) { attrs = {}; }
    var mountPoint = document.createElement('div');
    Object.keys(attrs).forEach(function (key) {
        mountPoint[key] = attrs[key];
    });
    if (styles) {
        setStyles(mountPoint, styles);
    }
    render(children, mountPoint);
    return mountPoint;
};
